import React, { HTMLAttributes, useState, useRef } from 'react';
import './Accordion.css';
import AccordionItem,{ AccordionEntry } from './components/AccordionItem';

export interface IAccordionProps extends HTMLAttributes<any> {
	items?: AccordionEntry[] | string[];
	firstOpen?: boolean;
	enableIcons?: boolean;
	disableBorder?: boolean;
	headerUnder?: boolean;
	backgroundColor?: 'white' | 'light-grey';
	openAllOnLoad?: boolean;
	disableExpandAll?: boolean;
	additionalOnClick?: THandlerFunction;
}

const Accordion = ({
	items = [],
	id,
	className = '',
	backgroundColor,
	firstOpen = false,
	openAllOnLoad = false,
	enableIcons = false,
	disableBorder = false,
	headerUnder= false,
	disableExpandAll =false,
	additionalOnClick,
}: IAccordionProps) => {
	const [activeIndices, setActiveIndices] = useState<number[]>(openAllOnLoad ? [...items.keys()]: [firstOpen ? 0 : -1]);
	const componentId = useRef<string>(id ? id : `accordion-${window.crypto.getRandomValues(new Uint32Array(1))[0]}`);

	const handleSingle = (index: number) => {
		if (activeIndices.includes(index)) {
			setActiveIndices([...activeIndices.filter(item => item !== index)]);
		} else {
			setActiveIndices([...activeIndices, index])
		}
	};

	const handleAll = () => {
		if (activeIndices.length === items.length) {
			setActiveIndices([]);
		} else {
			setActiveIndices([...items.keys()])
		}
	};

	return (
		<div className='Accordion' id={componentId.current}>
			<div className={`Accordion__contentContainer ${className}`}>
				<div className='Accordion__expandButtonContainer'>
					{!disableExpandAll &&
						<button className='Accordion__expandButton' onClick={handleAll}>
							{activeIndices.length === items.length ? 'Collapse All' : 'Expand All'}
							<span className={`Accordion__expandArrow ${activeIndices.length === items.length ? 'active' : ''}`} />
						</button>
					}
				</div>
				<ul className='Accordion__content'>
					{items && items.length && items.map((item, index) => 
						<AccordionItem
							id={componentId.current} 
							key={index} 
							item={item} 
							backgroundColor={backgroundColor}
							enableIcons={enableIcons} 
							disableBorder={disableBorder} 
							headerUnder={headerUnder}
							index={index} 
							active={activeIndices.includes(index)} 
							onClick={handleSingle} 
							additionalOnClick={additionalOnClick}
						/>
					)}
				</ul>
			</div>
		</div>
	);
};

export default Accordion;
